import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../Imagens/logoformari_horizontal.jpeg";
import api from "../../services/api";
import FieldLabel from "../../Components/FieldLabel";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { LoginContext } from "../../context/LoginContext";
import { getDashboardPath } from "../../auth/session";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { LoggedUser, Logged_in, signIn } = useContext(LoginContext);

  useEffect(() => {
    const destination = getDashboardPath(LoggedUser?.role);

    if (Logged_in && destination) {
      navigate(destination, { replace: true });
    }
  }, [LoggedUser?.role, Logged_in, navigate]);

  async function login(email, passwordValue) {
    try {
      const response = await api.post("/auth/signin", {
        email: email.trim(),
        password: passwordValue,
      });

      return {
        authenticated: await signIn(response.data),
        status: response.status,
      };
    } catch (error) {
      return { authenticated: false, status: error.response?.status };
    }
  }

  const handleLogin = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    setLoginError("");

    if (!usuario.trim() || !password) {
      setLoginError("Informe seu e-mail e sua senha.");
      return;
    }

    setIsSubmitting(true);

    try {
      const result = await login(usuario, password);

      if (!result.authenticated) {
        setLoginError(
          result.status === 401
            ? "Usuário e senha não conferem!"
            : "Não foi possível conectar à API. Verifique o backend e tente novamente.",
        );
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="TelaLoginCentralizada">
      <div className="LoginWrapper">
        <div className="login-container p-4 shadow">
          <img
            style={{ width: "100%", maxHeight: "300px", borderRadius: "10px" }}
            src={Logo}
            alt="Logo Formari"
          />

          <form style={{ paddingTop: "30px" }} onSubmit={handleLogin}>
            <div className="form-group mb-3" align="left">
              <FieldLabel label="E-mail">
                <input
                  type="email"
                  className="form-control form-control-lg"
                  placeholder="Email"
                  autoComplete="username"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                />
              </FieldLabel>
            </div>

            <div className="form-group mb-4" align="left">
              <div className="password-field">
                <label className="password-label" htmlFor="login-password">
                  Senha
                </label>
                <div className="password-input-wrapper">
                  <input
                    id="login-password"
                    type={passwordVisible ? "text" : "password"}
                    className="form-control form-control-lg"
                    placeholder="Senha"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    aria-label={passwordVisible ? "Ocultar senha" : "Mostrar senha"}
                    aria-pressed={passwordVisible}
                    aria-controls="login-password"
                    title={passwordVisible ? "Ocultar senha" : "Mostrar senha"}
                    onClick={() => setPasswordVisible((prev) => !prev)}
                  >
                    {passwordVisible ? (
                      <FaEyeSlash aria-hidden="true" />
                    ) : (
                      <FaEye aria-hidden="true" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {loginError ? (
              <p id="msm_senha" className="login-error" role="alert">
                {loginError}
              </p>
            ) : null}

            <button
              type="submit"
              className="btn btn-primary btn-lg w-100"
              disabled={isSubmitting}
            >
              {isSubmitting ? "ENTRANDO..." : "ENTRAR"}
            </button>

            <div className="login-links mt-3">
              <button type="button" onClick={() => navigate("/cadastro")} className="login-link">
                NOVO POR AQUI? REGISTRE-SE !
              </button>
              <div style={{ minWidth: "30px" }}></div>
              <button type="button" onClick={() => navigate("/esqueci-senha")} className="login-link">
                ESQUECI MINHA SENHA
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
